import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://1dae5802cb9a037f38e22f9217fab5cc@o4510689213415424.ingest.us.sentry.io/4510706283773952",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});